<template>
<div class="vtd-root" :style="themePageStyle">
  <nav class="vtd-topbar"><div class="container d-flex align-items-center justify-content-between py-2">
    <div class="d-flex align-items-center" style="gap:12px;">
      <back-button class="me-2" />
      <a href="javascript:void(0)" @click="$router.push('/')"><img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
      <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;">🩺 Vet Dashboard</span>
    </div>
    <button class="btn btn-sm btn-outline-warning" @click="$router.push('/vets')"><i class="mdi mdi-magnify me-1"></i>Find Vets</button>
  </div></nav>

  <div class="container vtd-container">
    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>
    <div v-else-if="!profile" class="text-center py-5">
      <i class="mdi mdi-stethoscope" style="font-size:64px;color:var(--fm-s,#3A3530);"></i>
      <h5 class="mt-3" style="color:var(--fm-h,#F5F0E8);">No Vet Profile</h5>
      <p style="color:var(--fm-s,#6B6356);">Register as a veterinarian to access your dashboard.</p>
      <button class="btn btn-warning mt-2" @click="openRegister"><i class="mdi mdi-plus me-1"></i>Register as Vet</button>
    </div>
    <div v-else>
      <!-- Profile header / status -->
      <div class="vtd-card mb-3 d-flex align-items-center justify-content-between" style="gap:12px;">
        <div class="d-flex align-items-center" style="gap:12px;min-width:0;">
          <div class="vtd-avatar" style="width:48px;height:48px;font-size:18px;">🩺</div>
          <div style="min-width:0;">
            <div style="color:var(--fm-h,#F5F0E8);font-weight:700;font-size:14px;">{{ profile.practice_name || 'Independent Vet' }}</div>
            <div style="color:var(--fm-s,#6B6356);font-size:11px;">KVB: {{ profile.kvb_registration_number }} <span v-if="profile.years_of_experience">· {{ profile.years_of_experience }} yrs</span></div>
            <div style="margin-top:3px;">
              <span class="vtd-status" :class="profile.status==='active' ? 'st-completed' : 'st-cancelled'">{{ profile.status==='active' ? 'Active' : 'Inactive' }}</span>
            </div>
          </div>
        </div>
        <button class="btn btn-sm btn-outline-warning" @click="openEdit"><i class="mdi mdi-pencil me-1"></i>Edit Profile</button>
      </div>

      <div v-if="profile.status!=='active'" class="vtd-alert" style="color:#FF9800;background:rgba(255,152,0,.08);border-color:rgba(255,152,0,.3);margin-bottom:14px;">
        <i class="mdi mdi-pause-circle-outline me-1"></i>Your profile is currently <strong>inactive</strong> — farmers cannot find or book you. Reactivate from Edit Profile.
      </div>

      <!-- Stats -->
      <div class="row g-3 mb-4">
        <div class="col-6 col-md-3"><div class="vtd-stat"><div class="vtd-stat-icon" style="color:#50C878;background:rgba(80,200,120,.1);"><i class="mdi mdi-check-circle"></i></div><div class="vtd-stat-val">{{ stats.totalConsultations }}</div><div class="vtd-stat-lbl">Completed</div></div></div>
        <div class="col-6 col-md-3"><div class="vtd-stat"><div class="vtd-stat-icon" style="color:#FF9800;background:rgba(255,152,0,.1);"><i class="mdi mdi-clock-alert"></i></div><div class="vtd-stat-val">{{ stats.pendingRequests }}</div><div class="vtd-stat-lbl">Pending</div></div></div>
        <div class="col-6 col-md-3"><div class="vtd-stat"><div class="vtd-stat-icon" style="color:#BFA164;background:rgba(191,161,100,.1);"><i class="mdi mdi-cash"></i></div><div class="vtd-stat-val">KES {{ fNum(stats.monthEarnings) }}</div><div class="vtd-stat-lbl">This Month</div></div></div>
        <div class="col-6 col-md-3"><div class="vtd-stat"><div class="vtd-stat-icon" style="color:#FFD700;background:rgba(255,215,0,.1);"><i class="mdi mdi-star"></i></div><div class="vtd-stat-val">{{ Number(stats.avgRating||0).toFixed(1) }}</div><div class="vtd-stat-lbl">Rating ({{ stats.totalReviews }})</div></div></div>
      </div>

      <!-- Tabs -->
      <div class="d-flex gap-2 mb-3 flex-wrap">
        <button v-for="tab in tabs" :key="tab.v" class="vtd-tab" :class="{active:activeTab===tab.v}" @click="activeTab=tab.v">
          {{ tab.l }} <span v-if="tab.v==='upcoming'" class="vtd-tab-badge">{{ upcoming.length }}</span>
        </button>
      </div>

      <!-- Upcoming Appointments -->
      <div v-if="activeTab==='upcoming'">
        <div v-if="!upcoming.length" class="vtd-card text-center py-4">
          <i class="mdi mdi-calendar-blank" style="font-size:36px;color:var(--fm-s,#3A3530);display:block;margin-bottom:8px;"></i>
          <div style="color:var(--fm-s,#6B6356);font-size:13px;">No upcoming appointments</div>
        </div>
        <div v-for="c in upcoming" :key="c.id" class="vtd-card mb-2" @click="$router.push('/vet/consultation/'+c.id)" style="cursor:pointer;">
          <div class="d-flex align-items-center gap-3">
            <div class="vtd-avatar">{{ (c.farmer_name||'F').charAt(0) }}</div>
            <div class="flex-fill">
              <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:13px;">{{ c.farmer_name }}</div>
              <div style="color:var(--fm-m,#A09888);font-size:12px;">{{ c.reason }}</div>
              <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:2px;">
                <span v-if="c.scheduled_date"><i class="mdi mdi-calendar me-1"></i>{{ c.scheduled_date }}</span>
                <span v-if="c.scheduled_time" class="ms-2"><i class="mdi mdi-clock me-1"></i>{{ c.scheduled_time }}</span>
                <span v-if="c.species_name" class="ms-2"><i class="mdi mdi-paw me-1"></i>{{ c.species_name }}</span>
              </div>
            </div>
            <div class="text-end">
              <span class="vtd-status" :class="'st-'+c.status">{{ c.status.replace(/_/g,' ') }}</span>
              <div style="color:#BFA164;font-weight:600;font-size:12px;margin-top:4px;">KES {{ Number(c.fee||0).toLocaleString() }}</div>
            </div>
          </div>
          <div v-if="c.status==='requested'" class="d-flex gap-2 mt-3 pt-2" style="border-top:1px solid var(--fm-br,#1E1E1E);">
            <button v-if="requiresPrepaymentGate(c)" class="btn btn-sm flex-fill" disabled style="background:rgba(255,152,0,.08);border:1px solid rgba(255,152,0,.3);color:#FF9800;cursor:not-allowed;" :title="'Awaiting farmer payment (KES '+fNum(c.fee)+')'">
              <i class="mdi mdi-cash-clock me-1"></i>Awaiting Payment
            </button>
            <button v-else class="btn btn-sm btn-outline-success flex-fill" @click.stop="updateStatus(c.id,'confirmed')"><i class="mdi mdi-check me-1"></i>Accept</button>
            <button class="btn btn-sm btn-outline-danger flex-fill" @click.stop="updateStatus(c.id,'cancelled')"><i class="mdi mdi-close me-1"></i>Decline</button>
          </div>
          <!-- PAYMENT ACTIONS — visible whenever the consultation isn't paid yet -->
          <div v-if="(c.payment_status||'pending')!=='paid' && (c.payment_status||'pending')!=='waived' && Number(c.fee||0) > 0" class="d-flex gap-2 mt-2 pt-2" style="border-top:1px solid var(--fm-br,#1E1E1E);">
            <!-- Waiting pill replaces the pay buttons while the STK/SMS result is in flight -->
            <div v-if="awaitingPayment.indexOf(c.id)!==-1" class="flex-fill text-center" style="background:rgba(255,152,0,.08);border:1px solid rgba(255,152,0,.3);color:#FF9800;border-radius:8px;padding:8px 12px;font-size:12px;font-weight:600;">
              <i class="mdi mdi-clock-outline me-1"></i>Waiting for payment…
            </div>
            <template v-else>
              <button class="btn btn-sm btn-outline-warning flex-fill" @click.stop="openPayActions(c, 'sms')" :disabled="payActionPending===c.id">
                <i class="mdi mdi-message-text me-1"></i>Send Pay Link
              </button>
              <button class="btn btn-sm btn-outline-warning flex-fill" @click.stop="openPayActions(c, 'stk')" :disabled="payActionPending===c.id">
                <i class="mdi mdi-cellphone-arrow-down me-1"></i>STK Push
              </button>
            </template>
          </div>
          <!-- Sticky "last attempt failed" pill when an STK came back with a non-zero ResultCode
               and the vet hasn't paid yet — same trace shown after the failure modal is dismissed. -->
          <div v-if="awaitingPayment.indexOf(c.id)===-1 && (c.payment_status||'pending')!=='paid' && c.last_stk_result_code !== null && Number(c.last_stk_result_code||0) !== 0" style="margin-top:6px;color:#FF6B6B;background:rgba(255,107,107,.08);border-radius:6px;padding:4px 8px;font-size:11px;display:inline-block;">
            <i class="mdi mdi-alert-circle-outline me-1"></i>Last attempt: {{ friendlyStkLabel(Number(c.last_stk_result_code), c.last_stk_result_desc) }}
          </div>
        </div>
      </div>

      <!-- Recent/Completed -->
      <div v-if="activeTab==='recent'">
        <div v-if="!recent.length" class="vtd-card text-center py-4">
          <div style="color:var(--fm-s,#6B6356);font-size:13px;">No completed consultations yet</div>
        </div>
        <div v-for="c in recent" :key="c.id" class="vtd-card mb-2" @click="$router.push('/vet/consultation/'+c.id)" style="cursor:pointer;">
          <div class="d-flex align-items-center gap-3">
            <div class="vtd-avatar" style="background:rgba(80,200,120,.1);color:#50C878;">✓</div>
            <div class="flex-fill">
              <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:13px;">{{ c.farmer_name }}</div>
              <div style="color:var(--fm-m,#A09888);font-size:12px;">{{ c.reason }}</div>
              <div style="color:var(--fm-s,#6B6356);font-size:10px;">{{ c.species_name }} · {{ formatDate(c.completed_at) }}</div>
            </div>
            <div style="color:#BFA164;font-weight:600;font-size:13px;">KES {{ Number(c.total_charge||c.fee||0).toLocaleString() }}</div>
          </div>
        </div>
      </div>

      <!-- Availability -->
      <div v-if="activeTab==='availability'">
        <div class="vtd-card">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 style="color:#BFA164;font-size:12px;font-weight:700;text-transform:uppercase;margin:0;">Weekly Schedule</h6>
            <button class="btn btn-sm btn-outline-warning" @click="toggleAvailEdit">
              <i class="mdi" :class="editingAvail ? 'mdi-check' : 'mdi-pencil-outline'"></i>
              {{ editingAvail ? 'Done' : 'Edit' }}
            </button>
          </div>
          <div v-for="d in 7" :key="d" class="vtd-avail-row" style="align-items:center;">
            <span class="vtd-avail-day">{{ dayName(d-1) }}</span>
            <!-- Read mode -->
            <template v-if="!editingAvail">
              <span v-if="getAvail(d-1) && Number(getAvail(d-1).is_available) === 1" style="color:var(--fm-h,#F5F0E8);font-size:12px;">
                {{ getAvail(d-1).start_time.substring(0,5) }} — {{ getAvail(d-1).end_time.substring(0,5) }}
              </span>
              <span v-else style="color:var(--fm-s,#6B6356);font-size:12px;">Not available</span>
            </template>
            <!-- Edit mode -->
            <div v-else class="d-flex align-items-center gap-2" style="flex-wrap:wrap;">
              <label class="d-flex align-items-center gap-1" style="cursor:pointer;font-size:11px;color:var(--fm-m,#A09888);">
                <input type="checkbox" :checked="isAvailEnabled(d-1)" @change="onAvailToggle(d-1, $event.target.checked)" />
                <span>Available</span>
              </label>
              <input type="time" :value="availStart(d-1)" @change="onAvailTimeChange(d-1,'start',$event.target.value)" :disabled="!isAvailEnabled(d-1)" style="background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;padding:4px 6px;border-radius:4px;font-size:11px;" />
              <span style="color:var(--fm-s,#6B6356);font-size:11px;">to</span>
              <input type="time" :value="availEnd(d-1)" @change="onAvailTimeChange(d-1,'end',$event.target.value)" :disabled="!isAvailEnabled(d-1)" style="background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;padding:4px 6px;border-radius:4px;font-size:11px;" />
            </div>
          </div>
          <div v-if="editingAvail" style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:8px;">
            <i class="mdi mdi-information-outline me-1"></i>Changes save automatically as you edit.
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ======= Toast ======= -->
  <transition name="vtd-toast-fade">
    <div v-if="toast.show" class="vtd-toast" :class="'toast-'+toast.type">
      <i class="mdi" :class="toast.type==='success' ? 'mdi-check-circle' : 'mdi-alert-circle'"></i>
      <span>{{ toast.msg }}</span>
    </div>
  </transition>

  <!-- ======= Vet Registration Modal ======= -->
  <div v-if="showRegister" class="vtd-overlay" @click.self="closeRegister">
    <div class="vtd-modal">
      <div class="vtd-modal-hd">
        <div>
          <div style="color:#BFA164;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;">{{ editMode ? 'Edit Profile' : 'Vet Onboarding' }}</div>
          <h5 style="color:var(--fm-h,#F5F0E8);margin:2px 0 0;font-size:17px;font-weight:700;">{{ editMode ? 'Update Vet Profile' : 'Register as a Veterinarian' }}</h5>
        </div>
        <button class="vtd-x" @click="closeRegister" aria-label="Close">&times;</button>
      </div>

      <div class="vtd-modal-bd">
        <div v-if="regError" class="vtd-alert">{{ regError }}</div>

        <h6 class="vtd-sect">Credentials</h6>
        <div class="row g-2">
          <div class="col-md-6">
            <label class="vtd-lbl">KVB Registration No. <span style="color:#FF6B6B">*</span></label>
            <input v-model="reg.kvbNumber" class="vtd-inp" placeholder="e.g. KVB/12345" />
          </div>
          <div class="col-md-6">
            <label class="vtd-lbl">Years of Experience</label>
            <input v-model.number="reg.yearsExperience" type="number" min="0" class="vtd-inp" placeholder="e.g. 5" />
          </div>
          <div class="col-12">
            <label class="vtd-lbl">Practice / Clinic Name</label>
            <input v-model="reg.practiceName" class="vtd-inp" placeholder="e.g. Savanna Vet Clinic" />
          </div>
          <div class="col-12">
            <label class="vtd-lbl">Short Bio</label>
            <textarea v-model="reg.bio" rows="2" class="vtd-inp" placeholder="Brief description of your practice, experience & focus areas" />
          </div>
        </div>

        <h6 class="vtd-sect mt-3">Specializations</h6>
        <div class="d-flex flex-wrap gap-2">
          <button type="button" v-for="s in specOptions" :key="s.v"
                  class="vtd-chip" :class="{active: reg.specializations.includes(s.v)}"
                  @click="toggleSpec(s.v)">{{ s.l }}</button>
        </div>

        <h6 class="vtd-sect mt-3">Services Offered</h6>
        <div class="d-flex flex-column gap-2">
          <label class="vtd-check"><input type="checkbox" v-model="reg.isMobile"/> <span>Farm visits (mobile service)</span></label>
          <label class="vtd-check"><input type="checkbox" v-model="reg.offersTelemedicine"/> <span>Telemedicine / video consultations</span></label>
          <label class="vtd-check"><input type="checkbox" v-model="reg.offersEmergency"/> <span>24/7 emergency service</span></label>
        </div>

        <h6 class="vtd-sect mt-3">Booking Policy</h6>
        <label class="vtd-check" style="align-items:flex-start;">
          <input type="checkbox" v-model="reg.requiresPrepayment" style="margin-top:3px;"/>
          <span>
            <strong>Require upfront payment before I accept appointments</strong>
            <div style="color:var(--fm-s,#6B6356);font-size:11px;font-weight:400;margin-top:2px;">Farmers must pay the consultation fee before you can confirm. Protects you from no-shows and time-wasters.</div>
          </span>
        </label>

        <h6 class="vtd-sect mt-3">Fees (KES)</h6>
        <div class="row g-2">
          <div class="col-6 col-md-3">
            <label class="vtd-lbl">Consultation</label>
            <input v-model.number="reg.consultationFee" type="number" min="0" class="vtd-inp" placeholder="0" />
          </div>
          <div class="col-6 col-md-3">
            <label class="vtd-lbl">Farm Visit</label>
            <input v-model.number="reg.farmVisitFee" type="number" min="0" class="vtd-inp" placeholder="0" />
          </div>
          <div class="col-6 col-md-3">
            <label class="vtd-lbl">Telemedicine</label>
            <input v-model.number="reg.telemedicineFee" type="number" min="0" class="vtd-inp" placeholder="0" :disabled="!reg.offersTelemedicine" />
          </div>
          <div class="col-6 col-md-3">
            <label class="vtd-lbl">Emergency</label>
            <input v-model.number="reg.emergencyFee" type="number" min="0" class="vtd-inp" placeholder="0" :disabled="!reg.offersEmergency" />
          </div>
        </div>

        <h6 class="vtd-sect mt-3">Clinic Location</h6>
        <div class="row g-2">
          <div class="col-12" style="position:relative;">
            <label class="vtd-lbl"><i class="mdi mdi-crosshairs-gps me-1" style="color:#BFA164;"></i>Clinic Address — search or pin on map</label>
            <div style="display:flex;gap:8px;">
              <div style="flex:1;position:relative;">
                <input v-model="reg.clinicAddress" type="text" class="vtd-inp" placeholder="Search town, market, area..." @input="onLocSearch" @focus="showLocResults=true" autocomplete="off" style="padding-right:36px;" />
                <i v-if="geoLoading" class="mdi mdi-loading mdi-spin" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);color:var(--fm-s,#6B6356);"></i>
                <i v-else-if="reg.clinicLatitude" class="mdi mdi-check-circle" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);color:#50C878;"></i>
              </div>
              <button type="button" class="vtd-gps-btn" @click="useMyLocation" :disabled="geoLoading" title="Use my current location">
                <i v-if="geoLoading" class="mdi mdi-loading mdi-spin"></i>
                <i v-else class="mdi mdi-crosshairs-gps"></i>
              </button>
            </div>
            <div v-if="showLocResults && locResults.length > 0" class="vtd-loc-dropdown">
              <div v-for="(loc, li) in locResults" :key="li" class="vtd-loc-item" @click="pickLocation(loc)">
                <i class="mdi mdi-map-marker" style="color:#BFA164;flex-shrink:0;margin-top:2px;"></i>
                <div>
                  <div style="font-size:13px;color:var(--fm-h,#F5F0E8);">{{ loc.display_name }}</div>
                  <div style="font-size:11px;color:var(--fm-s,#6B6356);">{{ loc.area }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="vtd-map-container">
              <div id="vetClinicMap" class="vtd-map"></div>
              <div class="vtd-map-hint"><i class="mdi mdi-gesture-tap me-1"></i>Tap the map to pin your clinic location</div>
            </div>
            <div v-if="reg.clinicLatitude && reg.clinicLongitude" style="font-size:11px;color:#50C878;margin-top:6px;">
              <i class="mdi mdi-check-circle me-1"></i>Location set
              <span style="color:var(--fm-s,#6B6356);">({{ Number(reg.clinicLatitude).toFixed(4) }}, {{ Number(reg.clinicLongitude).toFixed(4) }})</span>
            </div>
          </div>

          <div class="col-md-6">
            <label class="vtd-lbl">Service Radius (km)</label>
            <input v-model.number="reg.serviceRadiusKm" type="number" min="1" class="vtd-inp" placeholder="50" />
          </div>
        </div>
      </div>

      <div class="vtd-modal-ft">
        <button v-if="editMode && profile && profile.status==='active'" class="btn btn-sm btn-outline-danger me-auto" @click="deactivateProfile" :disabled="registering">
          <i class="mdi mdi-pause-circle-outline me-1"></i>Deactivate
        </button>
        <button v-else-if="editMode && profile && profile.status!=='active'" class="btn btn-sm btn-outline-success me-auto" @click="reactivateProfile" :disabled="registering">
          <i class="mdi mdi-play-circle-outline me-1"></i>Reactivate
        </button>
        <button class="btn btn-sm btn-outline-secondary" @click="closeRegister" :disabled="registering">Cancel</button>
        <button class="btn btn-sm btn-warning" @click="submitRegistration" :disabled="registering">
          <span v-if="registering" class="spinner-border spinner-border-sm me-1"></span>
          <i v-else class="mdi mdi-check-circle me-1"></i>
          {{ registering ? 'Saving…' : (editMode ? 'Save Changes' : 'Submit Registration') }}
        </button>
      </div>
    </div>
  </div>

  <!-- PAYMENT ACTION MODAL — Send SMS link OR initiate STK push -->
  <div v-if="payModal.show" class="vtd-overlay" @click.self="payModal.show=false">
    <div class="vtd-modal">
      <h6 class="m-0 fw-bold mb-2" style="color:var(--fm-h,#F5F0E8);">
        <i :class="payModal.mode==='sms' ? 'mdi mdi-message-text me-2' : 'mdi mdi-cellphone-arrow-down me-2'" style="color:#BFA164;"></i>
        {{ payModal.mode==='sms' ? 'Send Payment Link via SMS' : 'Initiate M-Pesa STK Push' }}
      </h6>
      <div v-if="payModal.consultation" style="font-size:12px;color:var(--fm-m,#A09888);margin-bottom:12px;">
        Consultation {{ payModal.consultation.consultation_ref }} — {{ payModal.consultation.farmer_name }} — <strong style="color:#BFA164;">KES {{ Number(payModal.consultation.fee||0).toLocaleString() }}</strong>
      </div>
      <div class="mb-2">
        <label style="font-size:11px;color:var(--fm-s,#6B6356);">Customer phone (M-Pesa)</label>
        <input v-model="payModal.phone" class="vtd-input w-100" placeholder="0712 345 678" />
        <small style="color:var(--fm-s,#6B6356);font-size:11px;">Default is the phone on file; override if paying from another number.</small>
      </div>
      <button class="btn btn-warning w-100" @click="confirmPayAction" :disabled="!payModal.phone || payModal.sending">
        <span v-if="payModal.sending"><span class="spinner-border spinner-border-sm me-1"></span>Sending…</span>
        <span v-else>{{ payModal.mode==='sms' ? 'Send SMS' : 'Push STK to phone' }}</span>
      </button>
      <button class="btn btn-link text-muted w-100 mt-1" @click="payModal.show=false" :disabled="payModal.sending">Cancel</button>
    </div>
  </div>

  <!-- ======= Payment Received modal — full receipt, stays open until vet hits Done ======= -->
  <div v-if="paidModal.show" class="vtd-overlay" style="z-index:600;" @click.self="paidModal.show=false">
    <div class="vtd-modal vtd-result-modal" style="max-width:420px;">
      <div style="text-align:center;padding:6px 4px 14px;">
        <div style="width:64px;height:64px;margin:0 auto;border-radius:50%;background:rgba(80,200,120,.15);display:flex;align-items:center;justify-content:center;">
          <i class="mdi mdi-check" style="font-size:36px;color:#50C878;font-weight:700;"></i>
        </div>
        <h5 style="color:var(--fm-h,#F5F0E8);margin:12px 0 4px;font-size:18px;font-weight:700;">Payment Received</h5>
        <div style="color:#50C878;font-size:26px;font-weight:700;">KES {{ Number(paidModal.c && (paidModal.c.paid_amount || paidModal.c.fee) || 0).toLocaleString() }}</div>
      </div>
      <div style="background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;padding:14px;">
        <div class="d-flex justify-content-between mb-2"><span style="color:var(--fm-s,#6B6356);font-size:12px;">M-Pesa receipt</span><strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ (paidModal.c && paidModal.c.paid_receipt) || '—' }}</strong></div>
        <div class="d-flex justify-content-between mb-2"><span style="color:var(--fm-s,#6B6356);font-size:12px;">Paid by</span><strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ (paidModal.c && (paidModal.c.paid_phone || paidModal.c.farmer_phone)) || '—' }}</strong></div>
        <div class="d-flex justify-content-between mb-2"><span style="color:var(--fm-s,#6B6356);font-size:12px;">Consultation</span><strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ (paidModal.c && paidModal.c.consultation_ref) || '—' }}</strong></div>
        <div class="d-flex justify-content-between"><span style="color:var(--fm-s,#6B6356);font-size:12px;">Paid at</span><strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ (paidModal.c && (paidModal.c.paid_at || '').split('.')[0]) || '—' }}</strong></div>
      </div>
      <button class="btn btn-warning w-100 mt-3" @click="paidModal.show=false">Done</button>
    </div>
  </div>

  <!-- ======= Payment Failed modal — reason + recovery actions, stays open until dismissed ======= -->
  <div v-if="failedModal.show" class="vtd-overlay" style="z-index:600;" @click.self="failedModal.show=false">
    <div class="vtd-modal vtd-result-modal" style="max-width:420px;">
      <div style="text-align:center;padding:6px 4px 14px;">
        <div style="width:64px;height:64px;margin:0 auto;border-radius:50%;background:rgba(255,107,107,.15);display:flex;align-items:center;justify-content:center;">
          <i class="mdi mdi-close" style="font-size:36px;color:#FF6B6B;font-weight:700;"></i>
        </div>
        <h5 style="color:var(--fm-h,#F5F0E8);margin:12px 0 4px;font-size:18px;font-weight:700;">Payment Failed</h5>
        <div style="color:#FF6B6B;font-size:14px;font-weight:600;">{{ failedModal.reason }}</div>
      </div>
      <div style="background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;padding:14px;">
        <div class="d-flex justify-content-between mb-2"><span style="color:var(--fm-s,#6B6356);font-size:12px;">Consultation</span><strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ (failedModal.c && failedModal.c.consultation_ref) || '—' }}</strong></div>
        <div class="d-flex justify-content-between mb-2"><span style="color:var(--fm-s,#6B6356);font-size:12px;">Amount</span><strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">KES {{ Number(failedModal.c && failedModal.c.fee || 0).toLocaleString() }}</strong></div>
        <div class="d-flex justify-content-between mb-2"><span style="color:var(--fm-s,#6B6356);font-size:12px;">Phone tried</span><strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ failedModal.phoneTried || '—' }}</strong></div>
        <div class="d-flex justify-content-between"><span style="color:var(--fm-s,#6B6356);font-size:12px;">At</span><strong style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ (failedModal.c && (failedModal.c.updated_at || failedModal.c.last_stk_attempted_at || '').split('.')[0]) || '—' }}</strong></div>
      </div>
      <button class="btn btn-warning w-100 mt-3" @click="resendStk"><i class="mdi mdi-refresh me-1"></i>Resend STK Push</button>
      <button class="btn btn-outline-warning w-100 mt-2" @click="tryDifferentNumber"><i class="mdi mdi-cellphone-cog me-1"></i>Try a different number</button>
      <button class="btn btn-link text-muted w-100 mt-1" @click="failedModal.show=false">Close</button>
    </div>
  </div>
</div>
</template>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] .vtd-root{background:#F7F5F2!important}
html[data-theme="light"] .vtd-topbar{background:rgba(255,255,255,.95)!important;border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .vtd-card,.vtd-stat{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .vtd-tab{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#555!important}
html[data-theme="light"] .vtd-tab.active{background:rgba(191,161,100,.1)!important;border-color:#BFA164!important;color:#BFA164!important}
.vtd-overlay{position:fixed;inset:0;background:rgba(0,0,0,.7);z-index:9999;display:flex;align-items:center;justify-content:center;padding:20px}
.vtd-modal{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#2A2520);border-radius:12px;padding:20px;width:100%;max-width:420px}
html[data-theme="light"] .vtd-modal{background:#FFFFFF!important;border-color:#E8E2DA!important}
.vtd-input{background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#2A2520);color:var(--fm-h,#F5F0E8);border-radius:6px;padding:8px 10px;font-size:13px}
html[data-theme="light"] .vtd-input{background:#F7F5F2!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
</style>

<style scoped>
.vtd-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh}
.vtd-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.vtd-container{padding-top:80px;padding-bottom:60px;max-width:900px}
.vtd-stat{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px;display:flex;align-items:center;gap:12px}
.vtd-stat-icon{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0}
.vtd-stat-val{font-size:18px;font-weight:700;color:var(--fm-h,#F5F0E8)}
.vtd-stat-lbl{font-size:10px;color:var(--fm-s,#6B6356)}
.vtd-tab{padding:8px 16px;border-radius:20px;border:1px solid var(--fm-br,#1E1E1E);background:var(--fm-bg1,#141414);color:var(--fm-m,#A09888);font-size:12px;cursor:pointer;transition:all .2s}
.vtd-tab.active{background:rgba(191,161,100,.1);border-color:#BFA164;color:#BFA164;font-weight:600}
.vtd-tab-badge{background:rgba(255,107,107,.15);color:#FF6B6B;padding:1px 6px;border-radius:8px;font-size:10px;margin-left:4px}
.vtd-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px}
.vtd-avatar{width:40px;height:40px;border-radius:50%;background:var(--fm-bg3,#1E1E1E);display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:700;color:#BFA164;flex-shrink:0}
.vtd-status{font-size:10px;font-weight:600;padding:2px 8px;border-radius:8px;text-transform:capitalize}
.st-requested{background:rgba(255,152,0,.1);color:#FF9800}
.st-confirmed{background:rgba(79,195,247,.1);color:#4FC3F7}
.st-in_progress{background:rgba(191,161,100,.1);color:#BFA164}
.st-completed{background:rgba(80,200,120,.1);color:#50C878}
.st-cancelled{background:rgba(255,107,107,.1);color:#FF6B6B}
.vtd-avail-row{display:flex;align-items:center;justify-content:space-between;padding:8px 0;border-bottom:1px solid var(--fm-br,#1A1A1A)}
.vtd-avail-row:last-child{border-bottom:none}
.vtd-avail-day{color:var(--fm-h,#F5F0E8);font-weight:600;font-size:12px;min-width:90px}

/* Register modal — z-index must sit above the global bottom nav (1100) so the sticky footer
   with the Submit Registration button is reachable on mobile. */
.vtd-overlay{position:fixed;inset:0;background:rgba(0,0,0,.75);z-index:2000;display:flex;align-items:center;justify-content:center;padding:16px;overflow-y:auto}
.vtd-modal{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;width:100%;max-width:620px;max-height:92vh;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,.5)}
.vtd-modal-hd{display:flex;align-items:flex-start;justify-content:space-between;padding:18px 20px;border-bottom:1px solid var(--fm-br,#1E1E1E)}
.vtd-modal-bd{padding:18px 20px;overflow-y:auto;flex:1}
.vtd-modal-ft{display:flex;justify-content:flex-end;gap:8px;padding:14px 20px;border-top:1px solid var(--fm-br,#1E1E1E)}
.vtd-x{background:transparent;border:none;color:var(--fm-m,#A09888);font-size:26px;line-height:1;cursor:pointer;padding:0 4px}
.vtd-x:hover{color:#FF6B6B}
.vtd-sect{color:#BFA164;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;margin:0 0 8px}
.vtd-lbl{display:block;color:var(--fm-m,#A09888);font-size:11px;font-weight:600;margin-bottom:4px}
.vtd-inp{width:100%;padding:8px 10px;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:6px;color:var(--fm-h,#F5F0E8);font-size:13px;outline:none;transition:border-color .15s}
.vtd-inp:focus{border-color:#BFA164}
.vtd-inp:disabled{opacity:.5;cursor:not-allowed}
.vtd-chip{padding:6px 12px;border-radius:16px;border:1px solid var(--fm-br,#1E1E1E);background:var(--fm-bg2,#0F0F0F);color:var(--fm-m,#A09888);font-size:12px;cursor:pointer;transition:all .15s}
.vtd-chip.active{background:rgba(191,161,100,.12);border-color:#BFA164;color:#BFA164;font-weight:600}
.vtd-check{display:flex;align-items:center;gap:8px;color:var(--fm-h,#F5F0E8);font-size:13px;cursor:pointer;user-select:none}
.vtd-check input{accent-color:#BFA164;width:16px;height:16px}
.vtd-alert{background:rgba(255,107,107,.1);border:1px solid rgba(255,107,107,.3);color:#FF6B6B;padding:8px 12px;border-radius:6px;font-size:12px;margin-bottom:12px}

/* Location search + map */
.vtd-gps-btn{width:40px;height:40px;display:flex;align-items:center;justify-content:center;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:6px;color:#BFA164;cursor:pointer;transition:all .15s;flex-shrink:0}
.vtd-gps-btn:hover:not(:disabled){background:rgba(191,161,100,.12);border-color:#BFA164}
.vtd-gps-btn:disabled{opacity:.5;cursor:not-allowed}
.vtd-loc-dropdown{position:absolute;left:0;right:48px;top:100%;background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:6px;max-height:240px;overflow-y:auto;z-index:10;box-shadow:0 8px 20px rgba(0,0,0,.4);margin-top:4px}
.vtd-loc-item{display:flex;align-items:flex-start;gap:8px;padding:10px 12px;cursor:pointer;border-bottom:1px solid var(--fm-br,#1A1A1A)}
.vtd-loc-item:hover{background:rgba(191,161,100,.08)}
.vtd-loc-item:last-child{border-bottom:none}
.vtd-map-container{position:relative;border-radius:8px;overflow:hidden;border:1px solid var(--fm-br,#1E1E1E)}
.vtd-map{width:100%;height:260px}
.vtd-map-hint{position:absolute;bottom:8px;left:8px;background:rgba(20,20,20,.85);color:#F5F0E8;font-size:11px;padding:4px 8px;border-radius:4px;pointer-events:none;backdrop-filter:blur(4px)}

/* Toast */
.vtd-toast{position:fixed;top:24px;left:50%;transform:translateX(-50%);z-index:900;display:flex;align-items:center;gap:10px;padding:12px 18px;border-radius:10px;font-size:13px;font-weight:600;box-shadow:0 10px 30px rgba(0,0,0,.4);max-width:92vw}
.vtd-toast .mdi{font-size:20px}
.vtd-toast.toast-success{background:#1E3A2B;border:1px solid #50C878;color:#9FE8B5}
.vtd-toast.toast-error{background:#3A1E1E;border:1px solid #FF6B6B;color:#FFB5B5}
.vtd-toast-fade-enter-active,.vtd-toast-fade-leave-active{transition:all .25s ease}
.vtd-toast-fade-enter-from{opacity:0;transform:translate(-50%,-12px)}
.vtd-toast-fade-leave-to{opacity:0;transform:translate(-50%,-12px)}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  /* Topbar — sticky, compact, safe-area padding for iOS notch. */
  .vtd-topbar { padding: 8px 0 !important; }
  .vtd-topbar .container { padding-left: 12px !important; padding-right: 12px !important; gap: 8px !important; }
  .vtd-topbar img { height: 28px !important; }
  .vtd-topbar .fw-semibold { font-size: 13px !important; }
  .vtd-topbar .btn-sm { font-size: 11px !important; padding: 4px 8px !important; }

  /* Container — tighter padding + safe-area awareness so content isn't cut by home bar. */
  .vtd-container { padding-top: 64px !important; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)) !important; padding-left: 12px !important; padding-right: 12px !important; }

  /* Profile header card — let Edit button drop below on narrow screens. */
  .vtd-card { padding: 12px !important; border-radius: 10px !important; }
  .vtd-card.mb-3.d-flex { flex-wrap: wrap !important; }
  .vtd-card.mb-3.d-flex > .d-flex { flex: 1 1 100% !important; }
  .vtd-card.mb-3.d-flex > .btn-outline-warning { width: 100% !important; margin-top: 8px !important; }

  /* Stats — 2 cols on mobile, tighter padding + smaller icon chips. */
  .vtd-stat { padding: 12px !important; gap: 10px !important; }
  .vtd-stat-icon { width: 34px !important; height: 34px !important; font-size: 16px !important; }
  .vtd-stat-val { font-size: 15px !important; }
  .vtd-stat-lbl { font-size: 10px !important; }

  /* Tabs — horizontal scroll instead of wrap so they stay in a single row on phones. */
  .vtd-container .d-flex.gap-2.mb-3.flex-wrap { flex-wrap: nowrap !important; overflow-x: auto !important; -webkit-overflow-scrolling: touch; scrollbar-width: none; padding-bottom: 2px; }
  .vtd-container .d-flex.gap-2.mb-3.flex-wrap::-webkit-scrollbar { display: none; }
  .vtd-tab { font-size: 12px; padding: 7px 14px; white-space: nowrap; flex-shrink: 0; }

  /* Appointment cards — let the right-column (status + fee) wrap below if the row is tight. */
  .vtd-card .d-flex.align-items-center.gap-3 { flex-wrap: wrap; gap: 10px !important; }
  .vtd-card .d-flex.align-items-center.gap-3 > .flex-fill { min-width: 0; flex: 1 1 50%; }
  .vtd-card .text-end { text-align: left !important; }

  /* Appointment action buttons (Accept/Decline + Pay Link/STK) — stack full-width on phones. */
  .vtd-card .d-flex.gap-2.mt-3,
  .vtd-card .d-flex.gap-2.mt-2 { flex-direction: column !important; gap: 6px !important; }
  .vtd-card .d-flex.gap-2.mt-3 .btn,
  .vtd-card .d-flex.gap-2.mt-2 .btn { width: 100%; }

  /* Toast above the bottom nav with safe-area. */
  .vtd-toast { font-size: 12px; padding: 8px 14px; top: auto; bottom: calc(90px + env(safe-area-inset-bottom, 0px)); }

  /* Registration / Edit modal — full-screen feel on mobile with sticky header + footer. */
  .vtd-overlay { padding: 0 !important; align-items: stretch !important; }
  .vtd-modal { max-width: 100% !important; max-height: 100% !important; height: 100%; border-radius: 0 !important; border: none !important; }
  .vtd-modal-hd { padding: 14px 16px !important; position: sticky; top: 0; background: var(--fm-bg1, #141414); z-index: 2; }
  html[data-theme="light"] .vtd-modal-hd { background: #FFFFFF !important; }
  .vtd-modal-bd { padding: 14px 16px !important; }
  .vtd-modal-ft { padding: 10px 14px calc(10px + env(safe-area-inset-bottom, 0px)) !important; flex-wrap: wrap; gap: 6px !important; position: sticky; bottom: 0; background: var(--fm-bg1, #141414); z-index: 2; }
  html[data-theme="light"] .vtd-modal-ft { background: #FFFFFF !important; }
  .vtd-modal-ft .btn { flex: 1 1 auto; }
  .vtd-modal-ft .btn.me-auto { flex: 1 1 100%; margin-right: 0 !important; margin-bottom: 4px; }

  /* Availability rows — tighter day label so the time fits cleanly. */
  .vtd-avail-day { min-width: 70px !important; font-size: 13px !important; }
}

/* Narrow phones — keep stats labels readable but compact. */
@media (max-width: 360px) {
  .vtd-stat-val { font-size: 13px !important; }
  .vtd-stat-lbl { font-size: 9px !important; }
  .vtd-stat-icon { width: 30px !important; height: 30px !important; font-size: 14px !important; }
}
</style>

<script>
/* eslint-disable */
import { executeJson, flocker } from "@/api";
export default {
  name: "VetDashboard",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,loading:true,
    profile:null,stats:{},upcoming:[],recent:[],availability:[],
    activeTab:'upcoming',showRegister:false,registering:false,regError:'',editMode:false,
    locResults:[],showLocResults:false,locSearchTimer:null,geoLoading:false,
    mapInstance:null,mapMarker:null,
    toast:{show:false,msg:'',type:'success'},toastTimer:null,
    reg:{kvbNumber:'',practiceName:'',bio:'',yearsExperience:null,specializations:[],isMobile:true,offersTelemedicine:false,offersEmergency:false,requiresPrepayment:false,consultationFee:null,farmVisitFee:null,telemedicineFee:null,emergencyFee:null,clinicAddress:'',clinicLatitude:null,clinicLongitude:null,serviceRadiusKm:50},
    specOptions:[
      {v:'large_animals',l:'Large Animals'},
      {v:'small_animals',l:'Small Animals'},
      {v:'poultry',l:'Poultry'},
      {v:'dairy',l:'Dairy'},
      {v:'reproduction',l:'Reproduction / AI'},
      {v:'surgery',l:'Surgery'},
      {v:'pathology',l:'Pathology'},
      {v:'nutrition',l:'Nutrition'}
    ],
    tabs:[{v:'upcoming',l:'Upcoming'},{v:'recent',l:'Completed'},{v:'availability',l:'Availability'}],
    payModal:{show:false, consultation:null, mode:'sms', phone:'', sending:false}, payActionPending:null,
    // Persistent set of consultation IDs awaiting an STK result + the success / failure modals.
    awaitingPayment:[],
    paymentPollTimer:null,
    paidModal:{show:false, c:null},
    failedModal:{show:false, c:null, reason:'', phoneTried:''},
    editingAvail:false, availSaveTimer:null
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'}
  },
  mounted(){
    var t=localStorage.getItem('flockr_theme')||'dark';window.__flockrSetTheme(t);
    this.darkMode=t!=='light';
    this.syncTheme();this.themeObserver=new MutationObserver(this.syncTheme);
    this.themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    this.restoreAwaiting();
    this.loadDashboard();
    // If there's a pending payment from before this mount, keep polling now.
    if (this.awaitingPayment.length) this.startPaymentPolling();
  },
  beforeUnmount(){if(this.themeObserver)this.themeObserver.disconnect();if(this.toastTimer)clearTimeout(this.toastTimer);if(this.locSearchTimer)clearTimeout(this.locSearchTimer);this.stopPaymentPolling();},
  methods:{
    syncTheme(){this.darkMode=document.documentElement.getAttribute('data-theme')!=='light'},
    requiresPrepaymentGate(c){
      return this.profile && String(this.profile.requires_prepayment)==='1' && (c.payment_status||'pending')!=='paid';
    },
    fNum(n){return Number(n||0).toLocaleString()},
    dayName(d){return['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'][d]||''},
    formatDate(d){if(!d)return'';return new Date(d).toLocaleDateString('en-KE',{day:'numeric',month:'short'})},
    getAvail(day){return this.availability.find(function(a){return parseInt(a.day_of_week)===day})},
    toggleAvailEdit(){this.editingAvail=!this.editingAvail;},
    isAvailEnabled(day){var a=this.getAvail(day);return !!(a && Number(a.is_available)===1);},
    availStart(day){var a=this.getAvail(day);return a&&a.start_time?a.start_time.substring(0,5):'08:00';},
    availEnd(day){var a=this.getAvail(day);return a&&a.end_time?a.end_time.substring(0,5):'17:00';},
    onAvailToggle(day, checked){
      var existing=this.getAvail(day);
      if(!existing){
        var row={day_of_week:day,start_time:'08:00:00',end_time:'17:00:00',is_available:checked?1:0};
        this.availability.push(row);
      }else{
        existing.is_available=checked?1:0;
        if(!existing.start_time) existing.start_time='08:00:00';
        if(!existing.end_time) existing.end_time='17:00:00';
      }
      this.persistAvail(day);
    },
    onAvailTimeChange(day, which, val){
      var existing=this.getAvail(day);
      if(!existing){
        existing={day_of_week:day,start_time:'08:00:00',end_time:'17:00:00',is_available:1};
        this.availability.push(existing);
      }
      var t=(val||'').length===5?val+':00':val;
      if(which==='start') existing.start_time=t; else existing.end_time=t;
      this.persistAvail(day);
    },
    persistAvail(day){
      var self=this;
      if(this.availSaveTimer) clearTimeout(this.availSaveTimer);
      this.availSaveTimer=setTimeout(async function(){
        var userId=sessionStorage.getItem('userId');
        var row=self.getAvail(day);if(!row) return;
        try{
          await executeJson({function:'setVetAvailability',vetUserId:userId,dayOfWeek:day,startTime:row.start_time,endTime:row.end_time,isAvailable:row.is_available?1:0},flocker);
          self.showToast('Schedule updated','success');
        }catch(e){ self.showToast('Save failed — please retry','danger'); }
      },350);
    },
    async loadDashboard(){
      this.loading=true;
      var userId=sessionStorage.getItem('userId');
      if(!userId){this.$router.push('/login');return}
      try{
        var r=await executeJson({function:'getVetDashboard',vetUserId:userId},flocker);
        if(r.data&&r.data.success&&r.data.data){
          this.profile=r.data.data.profile;
          this.stats=r.data.data.stats||{};
          this.upcoming=r.data.data.upcoming||[];
          this.recent=r.data.data.recent||[];
          this.availability=r.data.data.availability||[];
          // Reconcile any consultations that were awaiting payment when the page reloads —
          // a result may have come in while the polling timer wasn't active.
          this.reconcileAwaiting(this.upcoming, this.recent);
        }
      }catch(e){console.error(e)}
      this.loading=false;
    },
    openPayActions(consultation, mode){
      this.payModal.consultation = consultation;
      this.payModal.mode = mode;
      this.payModal.phone = consultation.farmer_phone || '';
      this.payModal.sending = false;
      this.payModal.show = true;
    },
    async confirmPayAction(){
      if (!this.payModal.consultation || !this.payModal.phone) return;
      this.payModal.sending = true;
      this.payActionPending = this.payModal.consultation.id;
      var consultationId = this.payModal.consultation.id;
      var mode = this.payModal.mode;
      var vetUserId = sessionStorage.getItem('userId') || '';
      var fn = mode === 'sms' ? 'vetSendPaymentLinkSms' : 'vetInitiateConsultationStkPush';
      try {
        var r = await executeJson({ function: fn, vetUserId: vetUserId, consultationId: consultationId, phone: this.payModal.phone }, flocker);
        if (r.data && r.data.success) {
          this.showToast(r.data.message || (mode === 'sms' ? 'Pay link sent' : 'STK push sent'), 'success');
          this.payModal.show = false;
          // Track this consultation as awaiting payment + start polling for the result.
          // Persisted in sessionStorage so the success/failure modal still fires if the vet
          // navigates away or refreshes the page during the M-Pesa flow.
          if (this.awaitingPayment.indexOf(consultationId) === -1) this.awaitingPayment.push(consultationId);
          this.persistAwaiting();
          this.startPaymentPolling();
        } else {
          this.showToast((r.data && r.data.message) || 'Failed', 'error');
        }
      } catch (e) { this.showToast('Network error', 'error'); }
      this.payModal.sending = false;
      this.payActionPending = null;
    },

    persistAwaiting(){
      try { sessionStorage.setItem('vetAwaitingPayment', JSON.stringify(this.awaitingPayment)); } catch (e) {}
    },
    restoreAwaiting(){
      try {
        var raw = sessionStorage.getItem('vetAwaitingPayment');
        if (raw) this.awaitingPayment = JSON.parse(raw) || [];
      } catch (e) { this.awaitingPayment = []; }
    },
    /** Poll getVetDashboard every 5s for up to 60s. Reconciles awaitingPayment entries
     *  against payment_status / last_stk_result_code and fires the success / failure modal. */
    startPaymentPolling(){
      if (this.paymentPollTimer) return; // already polling
      var self = this;
      var deadline = Date.now() + 60000;
      this.paymentPollTimer = setInterval(async function(){
        if (Date.now() > deadline || self.awaitingPayment.length === 0) { self.stopPaymentPolling(); return; }
        var vetUserId = sessionStorage.getItem('userId') || '';
        try {
          var r = await executeJson({ function: 'getVetDashboard', vetUserId: vetUserId }, flocker);
          if (r.data && r.data.success && r.data.data) self.reconcileAwaiting(r.data.data.upcoming || [], r.data.data.recent || []);
        } catch (e) {}
      }, 5000);
    },
    stopPaymentPolling(){
      if (this.paymentPollTimer) { clearInterval(this.paymentPollTimer); this.paymentPollTimer = null; }
    },
    /** Walk awaitingPayment, surface paid → success modal, failure code → failure modal,
     *  otherwise leave pending so the next poll/refresh keeps tracking. */
    reconcileAwaiting(upcoming, recent){
      if (!this.awaitingPayment.length) return;
      var lookup = {};
      (upcoming || []).forEach(function(c){ lookup[c.id] = c; });
      (recent || []).forEach(function(c){ lookup[c.id] = c; });
      var remaining = [];
      var paidFired = false;
      var failedFired = false;
      for (var i = 0; i < this.awaitingPayment.length; i++) {
        var id = this.awaitingPayment[i];
        var c = lookup[id];
        if (!c) { remaining.push(id); continue; }
        var code = c.last_stk_result_code !== null && c.last_stk_result_code !== undefined && c.last_stk_result_code !== ''
          ? parseInt(c.last_stk_result_code) : null;
        if (c.payment_status === 'paid' && !paidFired) {
          this.paidModal = { show: true, c: c }; paidFired = true;
        } else if (code !== null && code !== 0 && !failedFired) {
          // Prefer the friendly label — Daraja's raw text ("The initiator information is invalid.")
          // isn't actionable for the vet. Fall back to the raw desc only when there's no code mapping.
          var friendly = this.stkResultLabel(code);
          var reason = friendly.indexOf('Failed (code') === 0 ? (c.last_stk_result_desc || friendly) : friendly;
          var phoneTried = c.farmer_phone || '';
          this.failedModal = { show: true, c: c, reason: reason, phoneTried: phoneTried }; failedFired = true;
        } else if (c.payment_status !== 'paid' && (code === null || code === 0)) {
          remaining.push(id); // still pending — keep tracking
        }
      }
      if (remaining.length !== this.awaitingPayment.length) {
        this.awaitingPayment = remaining;
        this.persistAwaiting();
        if (remaining.length === 0) this.stopPaymentPolling();
        this.loadDashboard(); // refresh card UI (orange pill clears, paid moves to recent, etc.)
      }
    },
    stkResultLabel(code){
      switch (code) {
        case 1032: return 'Cancelled by user';
        case 1037: return 'No response — phone unreachable';
        case 2001: return 'Wrong PIN entered';
        case 1: return 'Insufficient funds';
        default: return 'Failed (code ' + code + ')';
      }
    },
    /** Friendly-first label — uses stkResultLabel mapping when we have one, falls back to the
     *  raw Daraja description only for unmapped codes. */
    friendlyStkLabel(code, rawDesc){
      var friendly = this.stkResultLabel(code);
      if (friendly.indexOf('Failed (code') === 0) return rawDesc || friendly;
      return friendly;
    },
    /** Resend STK to the same number from the failure modal — keeps the awaitingPayment
     *  entry and re-fires vetInitiateConsultationStkPush. */
    async resendStk(){
      var c = this.failedModal.c;
      var phone = this.failedModal.phoneTried;
      this.failedModal.show = false;
      if (!c || !phone) return;
      var vetUserId = sessionStorage.getItem('userId') || '';
      try {
        var r = await executeJson({ function: 'vetInitiateConsultationStkPush', vetUserId: vetUserId, consultationId: c.id, phone: phone }, flocker);
        if (r.data && r.data.success) {
          this.showToast(r.data.message || 'STK push sent', 'success');
          if (this.awaitingPayment.indexOf(c.id) === -1) this.awaitingPayment.push(c.id);
          this.persistAwaiting();
          this.startPaymentPolling();
          this.loadDashboard();
        } else {
          this.showToast((r.data && r.data.message) || 'Failed', 'error');
        }
      } catch (e) { this.showToast('Network error', 'error'); }
    },
    /** From the failure modal — re-open the pay picker so the vet can enter a different phone. */
    tryDifferentNumber(){
      var c = this.failedModal.c;
      this.failedModal.show = false;
      if (c) this.openPayActions(c, 'stk');
    },
    async updateStatus(consultationId,status){
      try{
        var actorUserId=sessionStorage.getItem('userId')||'';
        var payload={function:'updateConsultation',consultationId:consultationId,status:status,actorUserId:actorUserId};
        if(status==='cancelled'){
          var reason=prompt('Reason for cancellation (optional):','');
          if(reason!==null) payload.cancellationReason=reason;
        }
        var r=await executeJson(payload,flocker);
        if(r.data&&r.data.success){
          await this.loadDashboard();
          var labels={confirmed:'Appointment accepted — farmer notified',cancelled:'Appointment declined — farmer notified',en_route:'Marked on the way',in_progress:'Consultation started',completed:'Consultation completed',no_show:'Marked as no-show'};
          this.showToast(labels[status]||'Status updated','success');
        }else{
          this.showToast((r.data&&r.data.message)||'Failed to update status','error');
        }
      }catch(e){this.showToast('Network error — please try again','error');}
    },
    toggleSpec(v){
      var i=this.reg.specializations.indexOf(v);
      if(i>=0) this.reg.specializations.splice(i,1); else this.reg.specializations.push(v);
    },
    showToast(msg, type){
      if(this.toastTimer)clearTimeout(this.toastTimer);
      this.toast={show:true,msg:msg,type:type||'success'};
      var self=this;
      this.toastTimer=setTimeout(function(){self.toast.show=false;},3000);
    },
    openRegister(){
      this.editMode=false;
      this.reg={kvbNumber:'',practiceName:'',bio:'',yearsExperience:null,specializations:[],isMobile:true,offersTelemedicine:false,offersEmergency:false,requiresPrepayment:false,consultationFee:null,farmVisitFee:null,telemedicineFee:null,emergencyFee:null,clinicAddress:'',clinicLatitude:null,clinicLongitude:null,serviceRadiusKm:50};
      this.regError='';this.locResults=[];this.showLocResults=false;
      this.showRegister=true;
      var self=this;this.$nextTick(function(){self.initMap();});
    },
    openEdit(){
      if(!this.profile)return;
      var p=this.profile;
      var specs=[];try{specs=typeof p.specializations==='string'?JSON.parse(p.specializations||'[]'):(p.specializations||[]);}catch(e){specs=[];}
      this.editMode=true;
      this.reg={
        kvbNumber:p.kvb_registration_number||'',
        practiceName:p.practice_name||'',
        bio:p.bio||'',
        yearsExperience:p.years_of_experience?Number(p.years_of_experience):null,
        specializations:Array.isArray(specs)?specs:[],
        isMobile:String(p.is_mobile)==='1',
        offersTelemedicine:String(p.offers_telemedicine)==='1',
        offersEmergency:String(p.offers_emergency)==='1',
        requiresPrepayment:String(p.requires_prepayment)==='1',
        consultationFee:p.consultation_fee?Number(p.consultation_fee):null,
        farmVisitFee:p.farm_visit_fee?Number(p.farm_visit_fee):null,
        telemedicineFee:p.telemedicine_fee?Number(p.telemedicine_fee):null,
        emergencyFee:p.emergency_fee?Number(p.emergency_fee):null,
        clinicAddress:p.clinic_address||'',
        clinicLatitude:p.clinic_latitude?Number(p.clinic_latitude):null,
        clinicLongitude:p.clinic_longitude?Number(p.clinic_longitude):null,
        serviceRadiusKm:p.service_radius_km?Number(p.service_radius_km):50
      };
      this.regError='';this.locResults=[];this.showLocResults=false;
      this.showRegister=true;
      var self=this;this.$nextTick(function(){self.initMap();});
    },
    closeRegister(){
      if(this.registering)return;
      this.showRegister=false;this.regError='';this.editMode=false;
      this.locResults=[];this.showLocResults=false;
      if(this.mapInstance){try{this.mapInstance.remove();}catch(e){}this.mapInstance=null;this.mapMarker=null;}
      this.reg={kvbNumber:'',practiceName:'',bio:'',yearsExperience:null,specializations:[],isMobile:true,offersTelemedicine:false,offersEmergency:false,requiresPrepayment:false,consultationFee:null,farmVisitFee:null,telemedicineFee:null,emergencyFee:null,clinicAddress:'',clinicLatitude:null,clinicLongitude:null,serviceRadiusKm:50};
    },
    async submitRegistration(){
      this.regError='';
      var userId=sessionStorage.getItem('userId');
      if(!userId){this.$router.push('/login');return}
      if(!this.reg.kvbNumber||!String(this.reg.kvbNumber).trim()){this.regError='KVB registration number is required';return}
      this.registering=true;
      var payload={
        function:this.editMode?'updateVetProfile':'registerVet',
        userId:userId,
        kvbNumber:String(this.reg.kvbNumber).trim(),
        practiceName:this.reg.practiceName||'',
        bio:this.reg.bio||'',
        yearsExperience:this.reg.yearsExperience||'',
        specializations:JSON.stringify(this.reg.specializations||[]),
        serviceRadiusKm:this.reg.serviceRadiusKm||50,
        consultationFee:this.reg.consultationFee||'',
        farmVisitFee:this.reg.farmVisitFee||'',
        telemedicineFee:this.reg.offersTelemedicine?(this.reg.telemedicineFee||''):'',
        emergencyFee:this.reg.offersEmergency?(this.reg.emergencyFee||''):'',
        isMobile:this.reg.isMobile?'1':'0',
        offersTelemedicine:this.reg.offersTelemedicine?'1':'0',
        offersEmergency:this.reg.offersEmergency?'1':'0',
        requiresPrepayment:this.reg.requiresPrepayment?'1':'0',
        clinicAddress:this.reg.clinicAddress||'',
        clinicLatitude:this.reg.clinicLatitude||'',
        clinicLongitude:this.reg.clinicLongitude||''
      };
      var wasEdit=this.editMode;
      try{
        var r=await executeJson(payload,flocker);
        if(r.data&&r.data.success){
          await this.loadDashboard();
          this.registering=false;
          this.closeRegister();
          this.showToast(wasEdit?'Profile updated successfully':'Vet profile created successfully','success');
          return;
        }else{
          this.regError=(r.data&&r.data.message)||(wasEdit?'Update failed':'Registration failed');
        }
      }catch(e){
        this.regError=(e.response&&e.response.data&&e.response.data.message)||'Network error. Please try again.';
      }
      this.registering=false;
    },
    async deactivateProfile(){
      if(!confirm('Deactivate your vet profile? Farmers will no longer see you in search results until you reactivate.'))return;
      await this.setProfileStatus('inactive');
    },
    async reactivateProfile(){
      await this.setProfileStatus('active');
    },
    async setProfileStatus(status){
      var userId=sessionStorage.getItem('userId');
      if(!userId)return;
      this.registering=true;this.regError='';
      try{
        var r=await executeJson({function:'updateVetProfile',userId:userId,status:status},flocker);
        if(r.data&&r.data.success){
          await this.loadDashboard();
          this.registering=false;
          this.closeRegister();
          this.showToast(status==='active'?'Profile reactivated — you are visible to farmers again':'Profile deactivated','success');
          return;
        }else{
          this.regError=(r.data&&r.data.message)||'Failed to update status';
        }
      }catch(e){
        this.regError=(e.response&&e.response.data&&e.response.data.message)||'Network error';
      }
      this.registering=false;
    },

    // ===== LOCATION SEARCH (Nominatim) =====
    onLocSearch(){
      if(this.locSearchTimer)clearTimeout(this.locSearchTimer);
      var self=this;var q=String(this.reg.clinicAddress||'').trim();
      if(q.length<3){this.locResults=[];this.showLocResults=false;return;}
      this.locSearchTimer=setTimeout(function(){self.doLocSearch(q);},400);
    },
    async doLocSearch(q){
      try{
        var url='https://nominatim.openstreetmap.org/search?format=json&countrycodes=ke&limit=6&q='+encodeURIComponent(q);
        var res=await fetch(url);var data=await res.json();
        this.locResults=data.map(function(d){
          var parts=(d.display_name||'').split(',');
          return{display_name:parts.slice(0,3).join(', ').trim(),area:parts.slice(1,4).join(', ').trim(),lat:d.lat,lon:d.lon};
        });
        this.showLocResults=true;
      }catch(e){this.locResults=[];}
    },
    pickLocation(loc){
      this.reg.clinicLatitude=Number(loc.lat);
      this.reg.clinicLongitude=Number(loc.lon);
      this.reg.clinicAddress=loc.display_name;
      this.showLocResults=false;
      this.updatePin(Number(loc.lat),Number(loc.lon));
    },
    useMyLocation(){
      if(!navigator.geolocation)return;
      this.geoLoading=true;var self=this;
      navigator.geolocation.getCurrentPosition(
        function(pos){
          var lat=pos.coords.latitude,lon=pos.coords.longitude;
          self.reg.clinicLatitude=lat;self.reg.clinicLongitude=lon;
          self.geoLoading=false;
          self.updatePin(lat,lon);
          self.reverseGeocode(lat,lon);
        },
        function(){self.geoLoading=false;},
        {enableHighAccuracy:true,timeout:10000}
      );
    },
    reverseGeocode(lat,lon){
      var self=this;
      fetch('https://nominatim.openstreetmap.org/reverse?format=json&lat='+lat+'&lon='+lon)
        .then(function(r){return r.json();})
        .then(function(d){
          if(d&&d.display_name){
            var parts=d.display_name.split(',');
            self.reg.clinicAddress=parts.slice(0,3).join(',').trim();
          }
        }).catch(function(){});
    },
    loadLeaflet(cb){
      if(window.L){cb();return;}
      var css=document.createElement('link');
      css.rel='stylesheet';css.href='https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(css);
      var js=document.createElement('script');
      js.src='https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      js.onload=cb;
      document.head.appendChild(js);
    },
    initMap(){
      var self=this;
      this.loadLeaflet(function(){
        self.$nextTick(function(){
          var el=document.getElementById('vetClinicMap');
          if(!el)return;
          if(self.mapInstance){self.mapInstance.invalidateSize();return;}
          var lat=Number(self.reg.clinicLatitude)||-1.2921;
          var lon=Number(self.reg.clinicLongitude)||36.8219;
          var zoom=self.reg.clinicLatitude?14:7;
          self.mapInstance=L.map('vetClinicMap',{zoomControl:true,attributionControl:false}).setView([lat,lon],zoom);
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{maxZoom:18}).addTo(self.mapInstance);
          self.mapInstance.on('click',function(e){
            self.reg.clinicLatitude=e.latlng.lat;
            self.reg.clinicLongitude=e.latlng.lng;
            self.updatePin(e.latlng.lat,e.latlng.lng);
            self.reverseGeocode(e.latlng.lat,e.latlng.lng);
          });
          if(self.reg.clinicLatitude&&self.reg.clinicLongitude){
            self.updatePin(Number(self.reg.clinicLatitude),Number(self.reg.clinicLongitude));
          }
          setTimeout(function(){if(self.mapInstance)self.mapInstance.invalidateSize();},200);
        });
      });
    },
    updatePin(lat,lon){
      if(!this.mapInstance||!window.L)return;
      var pinIcon=L.divIcon({
        className:'vtd-pin-icon',
        html:'<div style="background:#BFA164;width:16px;height:16px;border-radius:50%;border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,0.5);"></div>',
        iconSize:[16,16],iconAnchor:[8,8]
      });
      if(this.mapMarker){
        this.mapMarker.setLatLng([lat,lon]);
      }else{
        this.mapMarker=L.marker([lat,lon],{icon:pinIcon,draggable:true})
          .addTo(this.mapInstance)
          .bindTooltip('Clinic location',{permanent:false,direction:'top'});
        var self=this;
        this.mapMarker.on('dragend',function(e){
          var pos=e.target.getLatLng();
          self.reg.clinicLatitude=pos.lat;
          self.reg.clinicLongitude=pos.lng;
          self.reverseGeocode(pos.lat,pos.lng);
        });
      }
      this.mapInstance.setView([lat,lon],Math.max(this.mapInstance.getZoom(),13));
    }
  }
};
</script>
